<div class="row" *ngIf="(tableItem | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="fw-bold">ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.thirdPartyCompanyID" disabled />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Name</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.thirdPartyCompanyName" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Code</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.thirdPartyCompanyCode" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">City</label>
                <city-state-zip-dropdown [parentForm]="formGroup"
                                         [ctrlName]="'cityCtrl'"
                                         [placeholder]="'Enter a City'"
                                         (citySelected)="citySTChanged($event, 'cityCtrl')"
                                         [cityID]="cityID"
                                         [defaultCity]="city?city.cityST:''"
                                         [isRequired]="true"></city-state-zip-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Address 1</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.address1" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Address 2</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.address2" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">External ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.externalCompanyID" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
